import { router, usePage } from "@inertiajs/react"
import { resetUser } from "@/lib/posthog"
import { Sentry } from "@/lib/sentry"

const useUser = () => {
  const {
    auth: { user },
  } = usePage().props

  const signOut = async () => {
    resetUser()
    Sentry.setUser(null)
    router.delete("/logout")
  }

  return {
    user,
    isAuthenticated: Boolean(user),
    isAdmin: Boolean(user?.is_admin),
    signOut,
  }
}

export default useUser
